import PopUpWarning from "./PopUpWarning";

export default PopUpWarning;
